import { createAsyncThunk } from '@reduxjs/toolkit';
import { multiPortfolioAssetAllocationThunkPayload } from '../../constants';
import container from '@ioc';
import { AssetClassList, IAuthenticationService, ILoggingService, PortfoliosAssetAllocation, PortfoliosServiceClient } from 'clientportalshared';
import { IAuthenticationService$ } from '@services/auth/IAuthentication.interface';
import { ILoggingService$ } from '@services/logging/ILoggingService.interface';
import appConfig from '@src/app/config/appConfig';
import { GetAssetAllocationRequest } from './types';
import { getAustralianDate } from '@src/app/utils/GenericUtils';

export const getAssetAllocationAsync = createAsyncThunk<PortfoliosAssetAllocation, GetAssetAllocationRequest>(
  multiPortfolioAssetAllocationThunkPayload,
  async (payload: GetAssetAllocationRequest) => {
    try {
      const authService = container.get<IAuthenticationService>(IAuthenticationService$);
      const loggingService = container.get<ILoggingService>(ILoggingService$);
      const portfoliosClient = new PortfoliosServiceClient(appConfig.apiEndpointUrl, authService, loggingService, appConfig);
      return await portfoliosClient.getMultiPortfolioAssetClassesAsync(getAustralianDate(payload.asOfDate), payload.clientPortfolios);
    } catch (e) {
      return {} as AssetClassList;
    }
  }
);
